import { motion } from 'framer-motion';
import styles from './Expertise.module.scss';
import { useInView } from 'react-intersection-observer';
import { FaDatabase, FaCloud, FaCode, FaCogs, FaBrain, FaTools } from 'react-icons/fa';
import { useTranslation } from 'react-i18next';

const Expertise = () => {
  const { t } = useTranslation();
  
  const skills = [
    {
      category: t('expertise.development.category'),
      position: "top",
      color: "#4299E1",
      icon: <FaCode />,
      details: [
        t('expertise.development.details.0'),
        t('expertise.development.details.1'),
        t('expertise.development.details.2')
      ]
    },
    {
      category: t('expertise.dataEngineering.category'),
      position: "topRight",
      color: "#48BB78",
      icon: <FaDatabase />,
      details: [
        t('expertise.dataEngineering.details.0'),
        t('expertise.dataEngineering.details.1'),
        t('expertise.dataEngineering.details.2')
      ]
    },
    {
      category: t('expertise.cloud.category'),
      position: "bottomRight",
      color: "#9F7AEA",
      icon: <FaCloud />,
      details: [
        t('expertise.cloud.details.0'),
        t('expertise.cloud.details.1'),
        t('expertise.cloud.details.2')
      ]
    },
    {
      category: t('expertise.systems.category'),
      position: "bottom",
      color: "#ED8936",
      icon: <FaCogs />,
      details: [
        t('expertise.systems.details.0'),
        t('expertise.systems.details.1'),
        t('expertise.systems.details.2')
      ]
    },
    {
      category: t('expertise.ai.category'),
      position: "bottomLeft",
      color: "#F687B3",
      icon: <FaBrain />,
      details: [
        t('expertise.ai.details.0'),
        t('expertise.ai.details.1'),
        t('expertise.ai.details.2')
      ]
    },
    {
      category: t('expertise.devops.category'),
      position: "topLeft",
      color: "#4FD1C5",
      icon: <FaTools />,
      details: [
        t('expertise.devops.details.0'),
        t('expertise.devops.details.1'),
        t('expertise.devops.details.2')
      ]
    }
  ];

  const [ref, inView] = useInView({
    threshold: 0.3,
    triggerOnce: true
  });

  const isMobile = window.innerWidth <= 1024;

  return (
    <section ref={ref} className={styles.expertise} id="expertise">
      <div className={styles.content}>
        <motion.h2
          initial={{ opacity: 0, y: 20 }}
          animate={inView ? { opacity: 1, y: 0 } : {}}
          transition={{ duration: 0.6 }}
        >
          {t('expertise.title')}
        </motion.h2>
        
        <div className={styles.hexContainer}>
          <div className={styles.hexBackground}>
            <motion.svg
              viewBox="0 0 800 800"
              className={styles.hexLines}
              initial={{ opacity: 0 }}
              animate={inView ? { opacity: 1 } : {}}
              transition={{ duration: 0.5, delay: 0.2 }}
            >
              <motion.path
                d="M400 100 L700 250 L700 550 L400 700 L100 550 L100 250 Z"
                fill="none"
                stroke="var(--text-primary)"
                strokeWidth="2"
                initial={{ pathLength: 0 }}
                animate={inView ? { pathLength: 1 } : {}}
                transition={{ duration: 1.5, ease: "easeInOut" }}
              />
            </motion.svg>
          </div>

          {skills.map((skill, index) => (
            <motion.div
              key={skill.category}
              className={`${styles.skillCard} ${styles[skill.position]}`}
              initial={{ opacity: 0, scale: isMobile ? 1 : 0.8 }}
              animate={inView ? { 
                opacity: 1, 
                scale: 1,
                transition: {
                  duration: isMobile ? 0.3 : 0.5,
                  delay: isMobile ? index * 0.1 : index * 0.2
                }
              } : {}}
              style={{ '--skill-color': skill.color }}
            >
              <div className={styles.cardContent}>
                <div className={styles.iconWrapper}>{skill.icon}</div>
                <h3>{skill.category}</h3>
                <ul>
                  {skill.details.map((detail, idx) => (
                    <motion.li
                      key={idx}
                      initial={{ opacity: 0, x: -20 }}
                      animate={inView ? { opacity: 1, x: 0 } : {}}
                      transition={{ duration: 0.5, delay: 0.8 + idx * 0.1 }}
                    >
                      {detail}
                    </motion.li>
                  ))}
                </ul>
              </div>
            </motion.div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default Expertise;